/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ILxsAnchorViewProps } from './lxs-anchor';

const LxsAnchorView: React.FC<ILxsAnchorViewProps> = ({ config, resources }) => {
    const { anchorId, linkText, buttonType } = config;

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>): void => {
        e.preventDefault();
        document.getElementById(anchorId)?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <a href={`#${anchorId}`} onClick={handleClick} className={`msc-cta__${buttonType}`} title={resources.anchorButtonTitle}>
            {linkText}
        </a>
    );
};

export default LxsAnchorView;
